import {
  Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, UpdateDateColumn, ManyToOne, JoinColumn,
} from 'typeorm';
import { SimNaoNaoSei } from '../types';
import { IsOptional, IsString, IsBoolean } from 'class-validator';
import { Paciente } from './Paciente';

@Entity({name: "planos_de_saude"})
export class PlanoDeSaude {
  @PrimaryGeneratedColumn()
  id?: number;

  @Column()
  paciente_id: number;

  @Column()
  @IsString()
  nome: string;
  
  @Column()
  @IsString()
  tipo: string;

  @Column({
    type: 'enum',
    enum: SimNaoNaoSei,
  })
  fim_carencia: SimNaoNaoSei;

  @Column()
  @IsBoolean()
  preferido: boolean;

  @CreateDateColumn()
  created?: Date;

  @Column()
  @IsOptional()
  created_by?: number | null;

  @UpdateDateColumn()
  updated?: Date;

  @Column()
  @IsOptional()
  updated_by?: number | null;

  // RELATIONS
  @ManyToOne(type => Paciente, paciente => paciente.planos_de_saude)
  @JoinColumn({ name: 'paciente_id' })
  paciente?: Paciente;
}
